export function WiseAceLogo({ size = 40, showText = true, light = false, className = "" }) {
  const textColor = light ? "#FFFFFF" : "#0B132B";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="wiseace-logo">
      <img src="/icons/wiseace-logo.png" width={size} height={size} alt="WiseAce Invoicing"
           style={{ width: size, height: size, borderRadius: Math.round(size * 0.22), objectFit: "contain" }} />
      {showText && (
        <div className="leading-none">
          <div className="font-display font-extrabold text-lg tracking-tight" style={{ color: textColor }}>
            Wise<span style={{ color: "#D4AF37" }}>Ace</span>
          </div>
          <div className="text-[10px] font-medium tracking-wider uppercase" style={{ color: light ? "#94A3B8" : "#64748B" }}>
            Invoicing
          </div>
        </div>
      )}
    </div>
  );
}
